import React, { useState, useEffect } from 'react';
import Select from 'components/Atom/Select';
import { Button } from 'components/Atom/Button';
import { BanksName } from 'utils/services';
import './style.css';
import { Form, notification } from 'antd';
import { paymentType } from 'utils/constant';

const Filter = ({ filtersData, handleClose, onSearch, filterToggler }) => {
  const [filterData, setFilterData] = useState(filtersData || {});
  useEffect(() => {
    setFilterData(filtersData || {});
  }, [filtersData]);
  const handleOnChangeValue = (e, type) => {
    if (e === null || e === 'all') {
      setFilterData((prevState) => {
        const newState = { ...prevState };
        delete newState[type];
        return newState;
      });
    } else {
      setFilterData((pre) => ({ ...pre, [type]: e }));
    }
  };
  const handleApplyFilters = () => {
    if (Object.keys(filterData ?? {})?.length > 0 || (Object.keys(filterData ?? {})?.length === 0 && Object.keys(filtersData ?? {})?.length > 0)) {
      onSearch(filterData);
      handleClose();
    } else {
      notification.warning({ message: 'At least one filter is required', placement: 'bottomRight' });
    }
  };
  const currentPaymentMethod = paymentType.find((pm) => pm.value === filterData?.paymentMethod) || paymentType[0];
  return (
    <div style={{ width: '100%', marginTop: '1rem', marginBottom: '0.75rem' }}>
      <Form layout='vertical'>
        <div className='custom-child transaction-filter' style={{ flexWrap: 'wrap', gap: '0', columnGap: '1.56rem' }}>
          <div>
            <Form.Item className='font-bold' label='Gateway'>
              <Select
                defaultValue={filterData?.gatewayType || 'all'}
                optionsValue={[{ label: 'All', value: 'all' }, ...BanksName]}
                handleChange={(e) => handleOnChangeValue(e.value, 'gatewayType')}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item className='font-bold' label='Payment Method'>
              <Select defaultValue={currentPaymentMethod} optionsValue={paymentType} handleChange={(e) => handleOnChangeValue(e.value, 'paymentMethod')} style={{ width: '100%' }} />
            </Form.Item>
          </div>
        </div>
        <div className='binClass mt-1'>
          <div className='float-start filter-btn'>
            <Button
              onClick={() => {
                handleApplyFilters();
                filterToggler();
              }}>
              Apply
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Filter;